<template>
  <div class="ins-kpi">
    <div class="ins-kpi-label">
      {{ card.label }}
      <InsInfoTip v-if="infoKey || tip" :text="tip" :term-key="infoKey" :glossary="glossary" />
    </div>
    <div class="ins-kpi-value">{{ fmt(card.current, card.unit) }}</div>
    <div class="ins-kpi-when">{{ card.current_label }}</div>
    <div class="ins-kpi-cmp">
      <div v-if="showSameMonth && card.same_month != null" class="ins-kpi-cmp-row">
        <span class="ins-kpi-cmp-lbl">{{ card.same_month_label || 'Yr ago' }}</span>
        <span class="ins-kpi-cmp-val">{{ fmt(card.same_month, card.unit) }}</span>
        <span v-if="card.same_month_delta_pct != null" class="ins-kpi-delta" :class="deltaClass(card.higher_is_better, card.same_month_delta_pct)">
          <span class="ins-kpi-delta-ar">{{ deltaArrow(card.same_month_delta_pct) }}</span>{{ fmtPct(absv(card.same_month_delta_pct)) }}
        </span>
      </div>
      <div class="ins-kpi-cmp-row"><span class="ins-kpi-cmp-lbl">YTD</span><span class="ins-kpi-cmp-val">{{ fmt(card.ytd, card.unit) }}</span></div>
      <div class="ins-kpi-cmp-row">
        <span class="ins-kpi-cmp-lbl">Yr ago YTD</span>
        <span class="ins-kpi-cmp-val">{{ fmt(card.prior_ytd, card.unit) }}</span>
        <span v-if="card.delta_pct != null" class="ins-kpi-delta" :class="deltaClass(card.higher_is_better, card.delta_pct)">
          <span class="ins-kpi-delta-ar">{{ deltaArrow(card.delta_pct) }}</span>{{ fmtPct(absv(card.delta_pct)) }}
        </span>
      </div>
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script>
/* Shared YoY overview card. Consumes one element of the standard /overview response
 * ({ key,label,unit,current,current_label, same_month, same_month_label, same_month_delta_pct,
 *    ytd, prior_ytd, delta_pct, higher_is_better }). `fmt(value, unit)` is supplied by the report
 * so number formatting stays report-owned. `showSameMonth` toggles the same-month-last-year row
 * (WOI omits it; FI/MI show it). */
import InsInfoTip from "./InsInfoTip.vue";
import { fmtPct, absv, deltaClass, deltaArrow } from "./insightsFormat";
export default {
  name: "InsOverviewCard",
  components: { InsInfoTip },
  props: {
    card: { type: Object, required: true },
    fmt: { type: Function, required: true },
    showSameMonth: { type: Boolean, default: false },
    infoKey: { type: String, default: "" },
    tip: { type: String, default: "" },
    glossary: { type: Object, default: () => ({}) },
  },
  methods: { fmtPct, absv, deltaClass, deltaArrow },
};
</script>
